import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { action } from 'mobx';
import { FormattedMessage } from 'ui/i18n';

import RadioSelect from './radio-select';
import './ConfirmMultipleEntryDropshipModal.scss';

@inject('CartState')
@observer
export default class ConfirmMultipleEntryDropshipModal extends Component {
	static propTypes = {
		CartState: PropTypes.object.isRequired,
		dropshipUps: PropTypes.any.isRequired,
		show: PropTypes.bool.isRequired,
		onRequestClose: PropTypes.func.isRequired,
		onRequestConfirm: PropTypes.func.isRequired,
	};

	@action
	onCancel() {
		this.props.onRequestClose();
	}

	@action
	onConfirm() {
		this.props.onRequestConfirm();
	}

	handleRadioSelect = id => {
		this.props.CartState.selectCandidate(id);
	};

	render() {
		const { dropshipUps, show } = this.props;

		return (
			<Modal
				className="ReactModal__Content ConfirmMultipleEntryDropshipModal"
				overlayClassName="ReactModal__Overlay"
				isOpen={show}
				onRequestClose={this.onCancel.bind(this)}
				onRequestConfirm={this.onConfirm.bind(this)}
				contentLabel="ConfirmMultipleEntryDropshipModal"
			>
				<h5 className="dropship-title">
					<FormattedMessage id="dropship.chooseAddress" />
				</h5>

				<div className="confirm-dropship-list">
					{dropshipUps.candidates.map(c => {
						const isChecked = this.props.CartState.selectedCandidateId === c.id;
						const state = this.props.CartState.handleState(
							c.countryCode,
							c.politicalDivision1
						);

						return (
							<RadioSelect
								key={c.id}
								id={c.id}
								isChecked={isChecked}
								onRadioSelect={this.handleRadioSelect}
								renderLabel={() =>
									<span>
										{c.address1 + (c.address2 ? `, ${c.address2}` : '')}
										<br />
										{`${c.politicalDivision2}, ${state}, ${c.postcodePrimaryLow}`}
									</span>}
							/>
						);
					})}
				</div>

				<div className="modal-controls">
					<button
						className="btn btn-primary"
						onClick={this.onConfirm.bind(this)}
					>
						<FormattedMessage id="ok.Button" />
					</button>

					<button
						className="btn btn-secondary"
						onClick={this.onCancel.bind(this)}
					>
						<FormattedMessage id="cancel.Button" />
					</button>
				</div>
			</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/ConfirmMultipleEntryDropshipModal/index.js